<template>
  <Card
    icon-class="icon-package"
    :title="firstTitle"
    :is-policy="true"
    :is-policy-details="isDetailHeader"
  >
    <template #content>
      <GridContent :with-padding="false">
        <template #gridContent>
          <dl class="info">
            <dt class="info__label">{{ $t('policyTile.policyNumber') }}</dt>
            <dd class="info__value">{{ policy.policyNumber }}</dd>
          </dl>
          <dl>
            <dt class="info__label">{{ $t('policyTile.statusLabel') }}</dt>
            <dd class="info__value">
              <span :class="statusClassesForPolicy(policy)"></span
              >{{
                policy.policyStatus
                  ? $t('policyTile.policyStatus.' + policy.policyStatus)
                  : ''
              }}
            </dd>
          </dl>
          <dl v-if="isDetailHeader && policy.beginningDatePolicy">
            <dt class="info__label">
              {{ $t('policyTile.beginningDatePolicy') }}
            </dt>
            <dd class="info__value">
              {{ formatDate(policy.beginningDatePolicy) }}
            </dd>
          </dl>
        </template>
      </GridContent>
    </template>
  </Card>
</template>
<script setup lang="ts">
import { type PropType, ref } from 'vue'
import type { Policy } from 'policies-api'
import { formatDate, statusClassesForPolicy } from '../../utils/policy/PolicyUtils'
import { Card, GridContent } from 'de-zurich-ui-library'

const props = defineProps({
  isDetailHeader: {
    type: Boolean,
    default: false
  },
  policy: {
    type: Object as PropType<Policy>,
    required: true
  }
})

const firstTitle = ref('Bündel')
if (props.policy.policyLines?.length === 1)
  firstTitle.value = props.policy.policyLines[0] ?? ''
</script>
